module.exports = "/_next/static/images/NewCriticalLifeCoverLogo-2b610c349cf625aebd8fed0c678772bb.svg";